export default {
  title: 'Here\'s What\'s Happening',
  kpis: {
    title: 'KPI Widgets',
    dashboard: 'Dashboard',
    reports: 'Reports',
    expandButton: 'KPIs',
    deleteKPI: 'Drag Kpis here to remove from display',
    dragKPI: 'Drag the KPI where you would like to view it in the dashboard',
    noAdditionalKPIs: 'There are no additional KPIs to display',
    addKPIButton: 'Add KPI',
    removeKPIButton: 'Remove KPI',
    customerFeedbackKPI: {
      title: 'Customer Feedback'
    },
    activeDispatchesKPI: {
      title: 'Active Dispatches',
      scheduled: 'Scheduled',
      onTime: 'On Time',
      delayed: 'Delayed'
    },
    providerAvailabilityKPI: {
      title: 'Provider Availability',
      active: 'Active',
      inActive: 'Inactive',
      idle: 'Idle'
    },
    scheduledDispatchesKPI: {
      title: 'Scheduled Dispatches',
      today: 'Today',
      tomorrow: 'Tomorrow',
      nextXDays: 'Next 7 Days'
    },
    onTimeDispatchesKPI: {
      title: 'On-Time Dispatches',
      subTitle: 'Today'
    },
    dispatchTypesKPI: {
      title: 'Dispatch Types',
      subTitle: 'Today',
      pickUp: 'Pick Up',
      dropOff: 'Drop Off'
    },
    dispatchMethodsKPI: {
      title: 'Dispatch Methods',
      subTitle: 'Today',
      valet: 'Valet',
      shuttle: 'Shuttle',
      loaner: 'Loaner',
      rideShare: 'Ride Share'
    },
    dispatchTotalsKPI: {
      title: 'Dispatch Totals',
      subTitle: 'Today',
      inProgress: 'In Progress',
      complete: 'Complete',
      cancelled: 'Cancelled'
    }
  },

  providerLocations: {
    title: 'Provider Locations'
  },
  activeProviders: {
    title: 'Active Providers',
    dispatches: 'dispatches today'
  }
};
